import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import Certificats from "./pages/Certificats";
import Ssiap from "./pages/Ssiap";
import CartesPro from "./pages/CartesPro";
import Incendie from "./pages/Incendie";
import Rappels from "./pages/Rappels";
import Actualites from "./pages/Actualites";
import Sessions from "./pages/Sessions";
import Utilisateurs from "./pages/Utilisateurs";
import Journal from "./pages/Journal";
import Personnalisation from "./pages/Personnalisation";
import MisesAJour from "./pages/MisesAJour";
import ErrorBoundary from "./components/ErrorBoundary";
import "@/index.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === undefined) return null;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  useEffect(() => {
    document.documentElement.classList.toggle("light", (localStorage.getItem("theme") || "dark") === "light");
  }, []);

  return (
    <AuthProvider>
      <BrandingProvider>
      <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="salaries" element={<Employees />} />
            <Route path="certificats" element={<Certificats />} />
            <Route path="ssiap" element={<Ssiap />} />
            <Route path="cartes-pro" element={<CartesPro />} />
            <Route path="formations-incendie" element={<Incendie />} />
            <Route path="rappels" element={<Rappels />} />
            <Route path="actualites" element={<Actualites />} />
            <Route path="mises-a-jour" element={<MisesAJour />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="utilisateurs" element={<Utilisateurs />} />
            <Route path="journal" element={<Journal />} />
            <Route path="personnalisation" element={<Personnalisation />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </ErrorBoundary>
      </BrandingProvider>
      <Toaster position="top-right" richColors theme="dark" />
    </AuthProvider>
  );
}

export default App;
